module.exports = __webpack_public_path__ + "assets/img/image_314.8fc5731e.png";